import React from 'react'
import { Chart, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Register necessary chart elements
ChartJS.register(ArcElement, Tooltip, Legend);




const DoughnutChart = ({height,width,chartData,labels}) => {
    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Count',
                data: chartData?? [0, 0],
                backgroundColor: [
                    'rgba(255, 206, 86, 0.7)',
                    '#8fbd04'
                ],
                borderWidth: 0,
            },
        ],
    };

    const options = {
        responsive: true,
        cutout: '70%',
        radius: '100%', // Controls doughnut thickness
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                // Disable the on-canvas tooltip
                enabled: false,

                external: function (context) {
                    // Tooltip Element
                    let tooltipEl = document.getElementById('chartjs-tooltip');

                    // Create element on first render
                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'chartjs-tooltip';
                        tooltipEl.innerHTML = '<table></table>';
                        document.body.appendChild(tooltipEl);
                    }

                    // Hide if no tooltip
                    const tooltipModel = context.tooltip;
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    // Set caret Position
                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                    if (tooltipModel.yAlign) {
                        tooltipEl.classList.add(tooltipModel.yAlign);
                    } else {
                        tooltipEl.classList.add('no-transform');
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines.map(item => item?.split(":")[1]?.trim() ?? '');
                    }

                    // Set Text
                    if (tooltipModel.body) {
                        //console.log(tooltipModel);
                        //console.log(tooltipModel.body.map(getBody));
                        
                        
                        const titleLines = tooltipModel.title || [];
                        const bodyLines = tooltipModel.body.map(getBody);

                        let innerHtml = '<tbody>';

                        bodyLines.forEach(function (body, i) {
                            const colors = tooltipModel.labelColors[i];
                            let style = 'background: black';
                            style += '; color: white';
                            style += '; border-radius: 5px';
                            style += '; padding: 5px 10px';
                            const span = '<span style="' + style + '">' + titleLines + ': ' + body + '</span>';
                            innerHtml += '<tr><td>' +  span + '</td></tr>';
                        });
                        innerHtml += '</tbody>';

                        let tableRoot = tooltipEl.querySelector('table');
                        tableRoot.innerHTML = innerHtml;
                    }

                    const position = context.chart.canvas.getBoundingClientRect();
                    const bodyFont = Chart.helpers?.toFont(tooltipModel.options.bodyFont);

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;
                    tooltipEl.style.position = 'absolute';
                    tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                    tooltipEl.style.font = bodyFont?.string;
                    tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
                    tooltipEl.style.pointerEvents = 'none';
                }
            }
        
        },
        animation: { animateRotate: true }

    };
  return (
      <div style={{ position: 'relative', height:height,width:width}}>
          <Doughnut data={data} options={options} />
      </div>
  )
}

export default DoughnutChart